module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Metas"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 200,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Las metas',
      "videoEmbed": "ADMINISTRACIONDINERO04LasMetas.mp4"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 300,
      "imaSrc": "contenido/diapositiva_5",
      "imaAlt": "Tres dardos en el centro de una diana"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeInRight dura_1",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('p', {
    staticClass: "adorn-bottom"
  }, [_vm._v("\n\n          Todas las personas deberían ponerse "), _c('strong', [_vm._v("objetivos")]), _vm._v(" o "), _c('strong', [_vm._v("metas")]), _vm._v(" frente a la administración del dinero a corto, mediano y largo plazo, y trabajar para cumplirlas."), _c('br'), _c('br'), _vm._v(" El "), _c('strong', [_vm._v("ahorro")]), _vm._v(" y la correcta "), _c('strong', [_vm._v("administración del dinero")]), _vm._v("          permiten alcanzar dichas metas. Para lograrlas de una manera más fácil, estas deben ser claras y estar bien definidas.\n\n        ")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e8f69f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-04.vue
// module id = 974
// module chunks = 1